<template>
    <t-space direction="vertical">
        <t-space direction="horizontal" style="margin-top: 1vh;">
            <t-space></t-space>
            <t-card title="库存信息" style="width: 85.5vw;">
                    <t-typography-text>
                        该页展示所有仓库中已存在的库存商品信息，信息入库前需要在采购统计中进行确认。通过在填写筛选条件，并点击搜索按钮后可对数据进行过滤
                    </t-typography-text>
            </t-card>
            <t-space></t-space>
        </t-space>
        <t-space direction="horizontal">
            <t-space></t-space>
            <t-card  style="width: 85.5vw; height: 8vh"> 
                <t-space>
                    <t-input v-model="criteriaWarehouseId" placeholder="请输入仓库编号"  tips="指定筛选的仓库编号">
                        <template #prefix-icon>
                            <search-icon />
                        </template>
                    </t-input>
                    <!-- <t-input v-model="criteriaCreateTime" placeholder="请输入入库时间" tips="指定筛选的入库时间">
                        <template #prefix-icon>
                            <search-icon />
                        </template>
                    </t-input> -->
                    <t-input v-model="criteriaGoodsName" placeholder="请输入商品名称" tips="指定筛选的商品名称">
                        <template #prefix-icon>
                            <search-icon />
                        </template>
                    </t-input>
                    <t-button variant="outline" :icon="renderIcon" theme="primary"  @click="Search"> 搜索 </t-button>
                </t-space>
            </t-card>
            <t-space></t-space>
        </t-space>
        <t-space direction="horizontal">
            <t-space>
            </t-space>
            <t-card title="库存信息" style="width: 85.5vw;">
                    <t-table
                        ref="tableRef"
                        row-key="index"
                        :resizable="true"
                        :pagination="pagination"
                        :data="goodsData"
                        :height="'50vh'"
                        cell-empty-content="-"
                        @row-edit="onRowEdit"
                        :editable-row-keys="editableRowKeys"
                        :columns="columns">
                    </t-table>
            </t-card>
            <t-space></t-space>
        </t-space>
        <t-dialog   v-model:visible="showQRCode"
                    header="货物二维码"
                    @confirm="() => { new PrintUtils('qrcode').printElement(); showQRCode = false;qrcode.innerHTML = ''}"
                    @close="() => { qrcode.innerHTML = '';showQRCode = false }"
                    @cancel="() => { qrcode.innerHTML = '';showQRCode = false}"
                    confirmBtn="打印">
                <div id="qrcode" ref="qrcode"></div>
            
        </t-dialog>
    </t-space>
</template>

<script lang="jsx" setup>
import request from '@/request/request';
import { Input,NotifyPlugin } from 'tdesign-vue-next';
import { SearchIcon } from 'tdesign-icons-vue-next';
import { nextTick, onMounted, ref } from 'vue';
import QRCode from "@/utils/QRCodeUtil";
import PrintUtils from '@/utils/printUtils';

const renderIcon = () => {
    return <SearchIcon />;
};

const showQRCode = ref(false)
const qrcode = ref(null)
const criteriaWarehouseId = ref('')
const criteriaGoodsName = ref('')
const tableRef = ref()
const currentSaveId = ref('')
const bufferRowData = ref({})
const goodsData = ref([])
const editableRowKeys = ref([])
const columns = [
    { title: '仓库编号', colKey: 'warehouseId' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    {title: '入库时间', colKey: 'createDateTime',width: 200},
    { title: '商品名称', colKey: 'goodsName' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    {
        title: '销售提成(%)', 
        colKey: 'saleReturnPointRatio',
        width: 150,
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '数量', colKey: 'amount' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '单价(元)', colKey: 'price' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '总计价值(元)', colKey: 'totalValue' ,width: 150,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '发票名称', colKey: 'nameOfInvoice' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '简称', colKey: 'briefName' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '存储位置', colKey: 'storageLocation' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '拼音码', colKey: 'pinyinCode' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '产地', colKey: 'placeOfProduction' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '商品税率', colKey: 'commodityTaxRate' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '重量(kg)', colKey: 'weight' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '商品标签', colKey: 'goodsTags' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '税码', colKey: 'taxCode' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '长度(cm)', colKey: 'length' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '宽度(cm)', colKey: 'width' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '高度(cm)', colKey: 'height' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '条形码策略', colKey: 'barcodeStrategy' ,width: 150,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '质保期(天)', colKey: 'qualityGuaranteePeriod' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '品牌', colKey: 'brand' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '规格', colKey: 'specifications' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '型号', colKey: 'model' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '参考成本', colKey: 'referenceCost' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '采购周期', colKey: 'purchasingCycle' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '备注', colKey: 'remarks' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '一级分类', colKey: 'firstLevelClassification' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '二级分类', colKey: 'secondLevelClassification' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { title: '三级分类', colKey: 'thirdLevelClassification' ,
    edit:{
            component: Input,
            showEditIcon: false
        }
    },
    {
        title: '操作栏',
        colKey: 'operate',
        fixed: 'right',
        width: 200,
        cell: (h, { row }) => {
            const editable = editableRowKeys.value.includes(row.index);
            return (
                <t-space class="table-operations" space="small">
                    {!editable && (
                        <t-link theme="primary" hover="color" data-id={row.index} onClick={QRCodeShow}>
                            二维码
                        </t-link>
                    )}
                    {!editable && (
                        <t-link theme="primary" hover="color" data-id={row.index} onClick={modifyDetails}>
                            修改
                        </t-link>
                    )}
                    {!editable && (
                        <t-link theme="danger" hover="color" data-id={row.index} onClick={deleteGoodsInfo}>
                            删除
                        </t-link>
                    )}
                    {editable && (
                        <t-link theme="primary" hover="color" data-id={row.index} onClick={onSave}>
                            保存
                        </t-link>
                    )}
                    {editable && (
                        <t-link theme="primary" hover="color" data-id={row.index} onClick={onCancel}>
                            取消
                        </t-link>
                    )}
                </t-space>
            );
        }
    }
];
const QRCodeShow =(e)=>{
    let index = e.target.dataset.id
    showQRCode.value = true
    nextTick(()=>{
        let packageCode = {
            goodsId: goodsData.value[index].goodsId,
            goodsName: goodsData.value[index].goodsName,
            amount: goodsData.value[index].amount,
            price: goodsData.value[index].price
        }
        QRCode.createQRCode(qrcode.value,JSON.stringify(packageCode))
    })
}
const Search = ()=>{
    request.RequestGoodsInfoAmountByCriteria({
        binding_user_id: parseInt(sessionStorage.getItem("user_id")),
        
    },(res)=>{
        if(res.data.success) {
            pagination.value.total = res.data.data
        }else{
            NotifyPlugin.error({
                title: "请求失败",
                content: '商品数量信息请求失败.' + res.data.tag,
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '商品数量信息请求失败.' + err,
            duration: 3000
        })
    })
    request.RequestGoodsInfo({
        binding_user_id: parseInt(sessionStorage.getItem("user_id")),
        warehouse_id: criteriaWarehouseId.value,
        goods_name: criteriaGoodsName.value,
        page_number: 0,
        page_size: 8
    },(res)=>{
        if(res.data.success) {
            goodsData.value = res.data.data
            for(let i = 0; i < goodsData.value.length; i++) {
                goodsData.value[i].index = i
            }
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '商品信息请求失败.' + res.data.tag,
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '商品信息请求失败.' + err,
            duration: 3000
        })
    })
}
const onSave = (e)=>{
    const {id} = e.currentTarget.dataset
    currentSaveId.value = id
    updateEditState(id)
    if(!Object.hasOwn(bufferRowData.value, 'index')) {
        Object.defineProperty(bufferRowData.value, 'index', {
            value: currentSaveId.value,
            enumerable: true,
            writable: true
        })
    }
    bufferRowData.value.index = id
    console.log("ON SAVE",goodsData.value)
    let newOne = {}
    Object.assign(newOne, bufferRowData.value)
    newOne.index = parseInt(newOne.index)
    request.RequestModifyGoodsInfo(goodsData.value[id].goodsId,newOne,
        (res)=>{
            if(res.data.success) {
                goodsData.value[id] = newOne
                tableRef.value.clearValidateData();
                bufferRowData.value = {}
                NotifyPlugin.success({
                    title: "修改成功",
                    content: '商品信息修改成功',
                    duration: 3000
                })
            } else {
                NotifyPlugin.error({
                    title: "修改失败",
                    content: '商品信息修改失败',
                    duration: 3000
                })
            }
        },(err)=>{
            NotifyPlugin.error({
                title: "修改失败",
                content: '商品信息修改失败.' + err,
                duration: 3000
            })
            
        })
}
const updateEditState = (id) => {
    const index = editableRowKeys.value.findIndex((t) => t === parseInt(id));
    editableRowKeys.value.splice(index, 1);
}
const onCancel = (e)=>{
    const { id } = e.currentTarget.dataset;
    updateEditState(id)
    tableRef.value.clearValidateData();
    bufferRowData.value = {};
}
const modifyDetails = (e)=>{
    const  id  = e.currentTarget.dataset.id
    if (!editableRowKeys.value.includes(id)) {
        editableRowKeys.value.push(parseInt(id));
        Object.assign(bufferRowData.value, goodsData.value[id])
    }
}

const deleteGoodsInfo = (e)=>{
    let index = e.target.dataset.id
    request.RequestDeleteGoodsInfo(goodsData.value[index].goodsId,
    (res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                title: "删除成功",
                content: '商品信息删除成功.',
                duration: 3000
            })
            goodsData.value.splice(index,1)
            pagination.value.total --
            for(let i = 0; i < goodsData.value.length; i++) {
                goodsData.value[i].index = i
            }
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '商品信息删除失败.' + res.data.tag,
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '商品信息删除失败.' + err,
            duration: 3000
        })
    })
}
const pagination = ref({
    pageSize: 8,
    defaultPageSize: 20,
    total: 100,
    defaultCurrent: 1,
    showPageSize: false,
    onCurrentChange: (number)=>{
        request.RequestGoodsInfo({
            binding_user_id: parseInt(sessionStorage.getItem("user_id")),
            page_number: number,
            page_size: 8
        },(res)=>{
            if(res.data.success) {
                goodsData.value = res.data.data
                for(let i = 0; i < goodsData.value.length; i++) {
                    goodsData.value[i].index = i
                }
            }else {
                NotifyPlugin.error({
                    title: "请求失败",
                    content: '商品信息请求失败.' + res.data.tag,
                })
            }
        },(err)=>{
            NotifyPlugin.error({
                title: "请求失败",
                content: '商品信息请求失败.' + err,
                duration: 3000
            })
        })
    }
});
const onRowEdit = (e)=>{
    if(!Object.hasOwn(bufferRowData.value, e.col.colKey)) {
        Object.defineProperty(bufferRowData.value, e.col.colKey, {
            value: e.value,
            enumerable: true,
            writable: true
        })
    }else {
        bufferRowData.value[e.col.colKey] = e.value
    }
}

onMounted(()=>{
    request.RequestGoodsInfo({
        binding_user_id: parseInt(sessionStorage.getItem("user_id")),
        page_number: 0,
        page_size: 8
    },(res)=>{
        if(res.data.success) {
            goodsData.value = res.data.data
            for(let i = 0; i < goodsData.value.length; i++) {
                goodsData.value[i].index = i
            }
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '商品信息请求失败.' + res.data.tag,
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '商品信息请求失败.' + err,
            duration: 3000
        })
    })
    request.RequestGoodsInfoAmount((res)=>{
        if(res.data.success) {
            pagination.value.total = res.data.data
        }else{
            NotifyPlugin.error({
                title: "请求失败",
                content: '商品数量信息请求失败.' + res.data.tag,
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '商品数量信息请求失败.' + err,
            duration: 3000
        })
    })
})

</script>

<style scoped>

</style>